import { CheckCircleIcon } from "@heroicons/react/outline";
import React, { useState } from "react";

export const RadioSelect = ({ options, values, isMulti = false, setValue }) => {
  const btnState = {};
  options.forEach((item) => {
    btnState[item.name] = values && values.includes(item.value);
  });

  const [buttons, setButtons] = useState(btnState);

  const onChange = (e, name) => {
    let newButtons = {};
    let empty = false;
    if (isMulti) {
      newButtons = { ...buttons, [e.target.innerText]: !buttons[name] };
    } else {
      Object.keys(buttons).forEach((t) => {
        if (buttons[t] && t === name) {
          empty = true;
          newButtons[t] = false;
        } else {
          newButtons[t] = t === name;
        }
      });
    }
    setButtons(newButtons);
    let value = null;
    if (isMulti) {
      value = Object.keys(newButtons)
        .filter((t) => newButtons[t])
        .map((key) => options.find((option) => key === option.name).value);
    } else if (empty) {
      value = undefined;
    } else {
      value = options.find((option) => name === option.name).value;
    }
    setValue(value);
  };

  return (
    <div>
      {Object.keys(buttons).map((name) => (
        <div
          key={name}
          className={`mt-3 ${
            buttons[name]
              ? "ring-2 ring-offset-2 ring-offset-sky-300 ring-white ring-opacity-60"
              : ""
          }
           ${buttons[name] ? "bg-sky-900 bg-opacity-75 text-white" : "bg-white"}
             relative rounded-lg shadow-md px-5 py-2 cursor-pointer flex focus:outline-none`}
          onClick={(e) => onChange(e, name)}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center">
              <div className="text-sm">
                <div
                  as="span"
                  className={`inline ${
                    buttons[name] ? "text-sky-100" : "text-black"
                  }`}
                >
                  <span>{name}</span>
                </div>
              </div>
            </div>
            {buttons[name] && (
              <div className="flex-shrink-0 text-white">
                <CheckCircleIcon className="w-6 h-6" />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
